// extracted by mini-css-extract-plugin
module.exports = {"title":"tech-page_style_title__21bBo"};